import { isEligibleBillableItem } from "./billingPresentation.js";
import { isValidBillingDateFilter } from "./billingPreferences.js";

/** Prestations prêtes regroupées par brouillon dont la période couvre leur date (`draft` nul : nouveau brouillon). */
export function billingDraftTargets(items) {
  const targets = new Map();
  for (const item of items) {
    const key = item?.draft?.id || "";
    if (!targets.has(key)) targets.set(key, { draft: item?.draft || null, ids: [] });
    targets.get(key).ids.push(item.id);
  }
  return [...targets.values()].sort((left, right) => Number(!left.draft) - Number(!right.draft));
}

/** Capture the actual services being previewed, independently of display filters.
 * period : jours choisis dans « À facturer » (semaine dernière, dates). Le serveur met chaque prestation dans le
 * brouillon qui couvre sa date ; un nouveau brouillon prend les jours libres de cette période. */
export function buildBillingDraftSelection(items, itemIds, period = null) {
  const ids = [...new Set(itemIds)];
  const byId = new Map(items.map((item) => [item.id, item]));
  const selectedItems = ids.map((id) => byId.get(id));
  if (!ids.length || selectedItems.some((item) => !isEligibleBillableItem(item))) {
    throw new Error("Certaines prestations ne sont plus disponibles. Actualisez la liste avant de créer le brouillon.");
  }
  const dates = selectedItems.map((item) => item.service_date);
  if (dates.some((date) => !date || !isValidBillingDateFilter(date))) {
    throw new Error("La date d’une prestation est manquante ou invalide. Actualisez la liste avant de créer le brouillon.");
  }
  dates.sort();
  const chosen = period?.from && period?.to && period.from <= dates[0] && dates.at(-1) <= period.to ? period : null;
  return Object.freeze({
    billable_item_ids: Object.freeze(ids),
    from_date: chosen?.from || dates[0],
    to_date: chosen?.to || dates.at(-1),
  });
}
